import apiClient from '@/lib/axios'

export const getNotifications = async (
  payload: NotificationFilters
): Promise<NotificationResponse> => {
  const response = await apiClient.get('/notifications', {
    params: payload,
  })
  return response.data
}

export const markNotificationsAsViewed = async (
  payload: MarkNotificationsAsViewedPayload
): Promise<MarkNotificationsAsViewedResponse> => {
  const response = await apiClient.post('/notifications/mark-as-viewed', payload)
  return response.data
}
